import { APPROVE_RECHARGE_REQUEST, APPROVE_RECHARGE_SUCCESS, APPROVE_RECHARGE_FAILURE, APPROVE_RECHARGE_RESET, } from "../../actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const approveRechargeReducer = (state = initialState, action) => {
    switch (action.type) {
        case APPROVE_RECHARGE_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: true, error: null });
        case APPROVE_RECHARGE_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case APPROVE_RECHARGE_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload, data: null });
        case APPROVE_RECHARGE_RESET:
            return Object.assign(Object.assign({}, state), { loading: false, data: null, error: null });
        default:
            return state;
    }
};
export default approveRechargeReducer;
